import getHTML from '@shared/get-html';
import dayjs from 'dayjs';

export function replacePlaceholder(
    text: string,
    placeholder: PromotionalCopy['placeholder'],
    highlightColor: string = '#E56051'
) {
    let _renderText = text;

    if (placeholder && typeof placeholder === 'object') {
        Object.entries(placeholder).forEach(([placeholderKey, placeholderValue]) => {
            const { type, value } = placeholderValue;

            const _value =
                type === 'timestamp'
                    ? dayjs.unix(Number(value)).format('MM/DD')
                    : String(value);

            const styledValue = `<span style="color: ${highlightColor}">${_value}</span>`;

            _renderText = _renderText.replace(`{${placeholderKey}}`, styledValue);
        });
    }

    return getHTML(_renderText, 'span');
}
